const isOldIe = () => {
  let jscriptVersion = new Function("/*@cc_on return @_jscript_version; @*/")();

  let isIe = jscriptVersion !== undefined;

  return isIe && jscriptVersion !== "11";
};

export const browserHelper = { isOldIe };
